import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import type SystemComponentDetailViewModel from "viewModels/administration/systemComponents/systemComponentDetailViewModel";
import type SystemComponentCreateViewModel from "viewModels/administration/systemComponents/systemComponentCreateViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";

export interface ComponentFormProps {
  vm: SystemComponentCreateViewModel | SystemComponentDetailViewModel;
  children?: React.ReactNode;
}

const SystemComponentForm = observer((props: ComponentFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="name">
          <FormLabel>{vm.translateAttribute("name")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="state">
          <FormLabel>{vm.translateAttribute("state")}</FormLabel>
          <AdvancedSelect items={vm.stateOptions} disabled={disabled} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="code">
          <FormLabel>{vm.translateAttribute("code")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default SystemComponentForm;
